export const DIGITAL_CHANNELS = [
  {
    number: "101",
    name: "HBO",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Sopranos", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Tony Soprano. The greatest TV drama ever made." },
      { title: "The Wire", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Baltimore. The corners. The institutions. All the pieces matter." },
      { title: "The Sopranos (Late)", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Another episode because HBO always ran this twice." },
      { title: "Oz", start: "11:00 PM", end: "12:00 AM", width: 2, rating: "TV-MA", genres: ["Drama"], summary: "Emerald City. The prison drama that started prestige TV." },
      { title: "Dennis Miller Live", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "TV-MA", genres: ["Comedy","Talk"], summary: "Strange old HBO rhythm at midnight." },
    ],
  },
  {
    number: "102",
    name: "HBO 2",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Deadwood", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Western"], summary: "The profanity-laced western masterpiece." },
      { title: "Rome", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","History"], summary: "Vorenus and Pullo. HBO's most expensive series." },
      { title: "HBO Documentary", start: "10:00 PM", end: "11:30 PM", width: 3, rating: "TV-14", genres: ["Documentary"], summary: "A prestige HBO documentary film." },
      { title: "HBO Late Film", start: "11:30 PM", end: "12:30 AM", width: 2, rating: "R", genres: ["Film"], summary: "A film from the HBO vault." },
    ],
  },
  {
    number: "103",
    name: "HBO Signature",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Six Feet Under", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama"], summary: "The Fisher family. Death and life in perfect balance." },
      { title: "Band of Brothers", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","War"], summary: "Easy Company. Spielberg and Hanks produced this." },
      { title: "True Blood", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Horror"], summary: "Sookie Stackhouse and vampires in Louisiana." },
      { title: "Classic HBO Film", start: "11:00 PM", end: "12:30 AM", width: 3, rating: "R", genres: ["Film"], summary: "A film from HBO's golden era catalog." },
    ],
  },
  {
    number: "104",
    name: "HBO Comedy",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Larry Sanders Show", start: "8:00 PM", end: "8:30 PM", width: 1, rating: "TV-MA", genres: ["Comedy"], summary: "The greatest show business satire." },
      { title: "Mr. Show with Bob and David", start: "8:30 PM", end: "9:00 PM", width: 1, rating: "TV-MA", genres: ["Comedy","Sketch"], summary: "Bob Odenkirk and David Cross. Ahead of its time." },
      { title: "Curb Your Enthusiasm", start: "9:00 PM", end: "9:30 PM", width: 1, rating: "TV-MA", genres: ["Comedy"], summary: "Pretty, pretty, pretty good." },
      { title: "Entourage", start: "9:30 PM", end: "10:00 PM", width: 1, rating: "TV-MA", genres: ["Comedy","Drama"], summary: "Vince, E, Turtle, Drama, Ari. HBO's bro comedy." },
      { title: "Chris Rock: Bigger & Blacker", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Comedy","Stand-Up"], summary: "The greatest stand-up special ever recorded." },
      { title: "Dave Chappelle: Killin' Them Softly", start: "11:00 PM", end: "12:00 AM", width: 2, rating: "TV-MA", genres: ["Comedy","Stand-Up"], summary: "Before the show. Pure comedy." },
      { title: "Stand-Up Block", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "TV-MA", genres: ["Comedy"], summary: "Late-night stand-up from the HBO vault." },
    ],
  },
  {
    number: "105",
    name: "HBO Family",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1503455637927-730bce8583c0?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Fraggle Rock", start: "8:00 PM", end: "8:30 PM", width: 1, rating: "TV-G", genres: ["Kids"], summary: "Jim Henson's underground world." },
      { title: "HBO Family Film", start: "8:30 PM", end: "10:30 PM", width: 4, rating: "PG", genres: ["Film","Family"], summary: "A family-friendly feature from the HBO vault." },
      { title: "HBO Family Special", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "TV-G", genres: ["Kids","Family"], summary: "Children's specials and programming." },
    ],
  },
  {
    number: "110",
    name: "Showtime",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Dexter", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Blood spatter analyst. Also serial killer." },
      { title: "Homeland", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Thriller"], summary: "Carrie Mathison vs. the world." },
      { title: "Shameless", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Comedy"], summary: "The Gallagher family. Chicago. Beautiful chaos." },
      { title: "Weeds", start: "11:00 PM", end: "12:00 AM", width: 2, rating: "TV-MA", genres: ["Drama","Comedy"], summary: "Nancy Botwin sells weed in the suburbs." },
      { title: "Penn & Teller: Bullshit!", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "TV-MA", genres: ["Documentary","Comedy"], summary: "Debunking nonsense. Loudly." },
    ],
  },
  {
    number: "111",
    name: "Showtime 2",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Nurse Jackie", start: "8:00 PM", end: "8:30 PM", width: 1, rating: "TV-MA", genres: ["Drama","Comedy"], summary: "Edie Falco as an ER nurse with a pill problem." },
      { title: "The Tudors", start: "8:30 PM", end: "9:30 PM", width: 2, rating: "TV-MA", genres: ["Drama","History"], summary: "Henry VIII with abs and drama." },
      { title: "Ray Donovan", start: "9:30 PM", end: "10:30 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Hollywood fixer. Liev Schreiber at his best." },
      { title: "Brotherhood", start: "10:30 PM", end: "11:30 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Two brothers on opposite sides of the law in Providence, RI." },
      { title: "Showtime Late Film", start: "11:30 PM", end: "12:30 AM", width: 2, rating: "R", genres: ["Film"], summary: "Exactly what you'd secretly stay up too late for." },
    ],
  },
  {
    number: "112",
    name: "Showtime Extreme",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Action Feature", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "R", genres: ["Film","Action"], summary: "Uncut action cinema. The premium block should feel like a reward." },
      { title: "Thriller Feature", start: "10:00 PM", end: "12:00 AM", width: 4, rating: "R", genres: ["Film","Thriller"], summary: "Something dark and tense at 10pm." },
      { title: "Showtime Extreme Late", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "R", genres: ["Film"], summary: "The uncut midnight block." },
    ],
  },
  {
    number: "113",
    name: "Showtime Women",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The L Word", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama"], summary: "The groundbreaking Showtime series." },
      { title: "Women's Feature Film", start: "9:00 PM", end: "11:00 PM", width: 4, rating: "R", genres: ["Film","Drama"], summary: "A film anchored by a female lead." },
      { title: "Showtime Women Late", start: "11:00 PM", end: "12:30 AM", width: 3, rating: "TV-14", genres: ["Drama"], summary: "Drama and film block." },
    ],
  },
  {
    number: "120",
    name: "Cinemax",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Action Feature", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "R", genres: ["Film","Action"], summary: "High-octane Cinemax action film." },
      { title: "Strike Back", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Action"], summary: "Cinemax's own prestige action series." },
      { title: "Skinemax Block", start: "11:00 PM", end: "12:30 AM", width: 3, rating: "TV-MA", genres: ["Film"], summary: "The reputation was earned. Late-night Cinemax is what it is." },
    ],
  },
  {
    number: "121",
    name: "MoreMAX",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Cinemax Overflow Film", start: "8:00 PM", end: "10:30 PM", width: 5, rating: "R", genres: ["Film"], summary: "The secondary Cinemax film block." },
      { title: "B-Movie Block", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "R", genres: ["Film"], summary: "The B-tier films that still have their charm." },
    ],
  },
  {
    number: "130",
    name: "The Movie Channel",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Indie Feature", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "R", genres: ["Film","Indie"], summary: "The kind of film you find on The Movie Channel." },
      { title: "Foreign Film", start: "10:00 PM", end: "12:00 AM", width: 4, rating: "NR", genres: ["Film","Foreign"], summary: "International cinema. Subtitled." },
      { title: "Cult Classic Short", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "R", genres: ["Film","Cult"], summary: "Something strange at midnight." },
    ],
  },
  {
    number: "140",
    name: "Starz Premium",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Power", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Ghost's empire. Courtney Kemp and 50 Cent." },
      { title: "Outlander", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Romance"], summary: "Claire and Jamie. Time travel and Scotland." },
      { title: "Spartacus: Blood and Sand", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Action"], summary: "Andy Whitfield. An all-time great TV run." },
      { title: "Starz Film", start: "11:00 PM", end: "12:30 AM", width: 3, rating: "R", genres: ["Film"], summary: "Premium Starz feature." },
    ],
  },
  {
    number: "141",
    name: "Starz Edge",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Action Feature", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "R", genres: ["Film","Action"], summary: "Starz Edge action block. Genre movies." },
      { title: "Sci-Fi Feature", start: "10:00 PM", end: "12:00 AM", width: 4, rating: "R", genres: ["Film","Sci-Fi"], summary: "Science fiction from the Starz catalog." },
      { title: "Starz Edge Late", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "R", genres: ["Film"], summary: "Midnight on Starz Edge." },
    ],
  },
  {
    number: "142",
    name: "Starz Kids & Family",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1503455637927-730bce8583c0?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Family Feature", start: "8:00 PM", end: "10:00 PM", width: 4, rating: "PG", genres: ["Film","Family"], summary: "A family-friendly Starz feature." },
      { title: "Kids Block", start: "10:00 PM", end: "12:30 AM", width: 5, rating: "G", genres: ["Film","Kids"], summary: "Animation and kids films." },
    ],
  },
  {
    number: "150",
    name: "Epix",
    category: "DIGITAL PREMIUM",
    preview: "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Epix Feature Film", start: "8:00 PM", end: "10:30 PM", width: 5, rating: "R", genres: ["Film"], summary: "Premium Epix feature presentation." },
      { title: "Concert Film", start: "10:30 PM", end: "12:30 AM", width: 4, rating: "TV-PG", genres: ["Music"], summary: "A legendary artist in concert." },
    ],
  },
  {
    number: "160",
    name: "Netflix",
    category: "STREAMING HIGHLIGHT",
    preview: "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Stranger Things", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-14", genres: ["Sci-Fi","Drama","Horror"], summary: "Hawkins, Indiana. The Upside Down. Pure 80s nostalgia." },
      { title: "Ozark", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Marty Byrde money laundering in the Ozarks." },
      { title: "Mindhunter", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Fincher's FBI behavioral science unit. Chilling." },
      { title: "Narcos", start: "11:00 PM", end: "12:00 AM", width: 2, rating: "TV-MA", genres: ["Drama","Crime"], summary: "Pablo Escobar. Plata o plomo." },
      { title: "Making a Murderer", start: "12:00 AM", end: "12:30 AM", width: 1, rating: "TV-MA", genres: ["Documentary","Crime"], summary: "Steven Avery. The doc that broke Netflix." },
    ],
  },
  {
    number: "161",
    name: "Netflix 2",
    category: "STREAMING HIGHLIGHT",
    preview: "https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "House of Cards", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Politics"], summary: "Francis Underwood's rise. Netflix's first original." },
      { title: "The Crown", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","History"], summary: "The British monarchy in remarkable detail." },
      { title: "BoJack Horseman", start: "10:00 PM", end: "10:30 PM", width: 1, rating: "TV-MA", genres: ["Animation","Comedy","Drama"], summary: "The most honest show about depression ever made." },
      { title: "The Haunting of Hill House", start: "10:30 PM", end: "11:30 PM", width: 2, rating: "TV-MA", genres: ["Horror","Drama"], summary: "Mike Flanagan. The best horror series on streaming." },
      { title: "Dark", start: "11:30 PM", end: "12:30 AM", width: 2, rating: "TV-MA", genres: ["Sci-Fi","Drama","Mystery"], summary: "German time travel. Every character is their own ancestor." },
    ],
  },
  {
    number: "170",
    name: "Prime Video",
    category: "STREAMING HIGHLIGHT",
    preview: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Boys", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Action","Satire"], summary: "What if superheroes were corporate sociopaths?" },
      { title: "The Marvelous Mrs. Maisel", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Comedy"], summary: "1950s housewife becomes a stand-up comedian." },
      { title: "Fleabag", start: "10:00 PM", end: "10:30 PM", width: 1, rating: "TV-MA", genres: ["Comedy","Drama"], summary: "Phoebe Waller-Bridge breaking the fourth wall and your heart." },
      { title: "Reacher", start: "10:30 PM", end: "11:30 PM", width: 2, rating: "TV-MA", genres: ["Action","Drama"], summary: "Jack Reacher. Big guy, bigger consequences." },
      { title: "Patriot", start: "11:30 PM", end: "12:30 AM", width: 2, rating: "TV-MA", genres: ["Drama","Comedy"], summary: "The most underrated Prime show. A spy folksingers drama." },
    ],
  },
  {
    number: "180",
    name: "Hulu",
    category: "STREAMING HIGHLIGHT",
    preview: "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Handmaid's Tale", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Sci-Fi"], summary: "Gilead. Offred. Elisabeth Moss." },
      { title: "Only Murders in the Building", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-14", genres: ["Comedy","Mystery"], summary: "Steve Martin, Martin Short, Selena Gomez solving murders." },
      { title: "PEN15", start: "10:00 PM", end: "10:30 PM", width: 1, rating: "TV-MA", genres: ["Comedy"], summary: "Two adult women playing 13-year-old versions of themselves. Brilliant." },
      { title: "Castle Rock", start: "10:30 PM", end: "11:30 PM", width: 2, rating: "TV-MA", genres: ["Horror","Drama"], summary: "Stephen King's universe woven together." },
      { title: "Little Fires Everywhere", start: "11:30 PM", end: "12:30 AM", width: 2, rating: "TV-MA", genres: ["Drama"], summary: "Reese Witherspoon and Kerry Washington in Shaker Heights." },
    ],
  },
  {
    number: "190",
    name: "Apple TV+",
    category: "STREAMING HIGHLIGHT",
    preview: "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "Severance", start: "8:00 PM", end: "9:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Sci-Fi","Thriller"], summary: "Lumon Industries. Work and life separated. The best premise in years." },
      { title: "Slow Horses", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Thriller"], summary: "Gary Oldman leading MI5's reject team." },
      { title: "Ted Lasso", start: "10:00 PM", end: "10:30 PM", width: 1, rating: "TV-MA", genres: ["Comedy","Drama"], summary: "Believe. The most optimistic sports show ever made." },
      { title: "The Morning Show", start: "10:30 PM", end: "11:30 PM", width: 2, rating: "TV-MA", genres: ["Drama"], summary: "Jennifer Aniston and Reese Witherspoon in morning TV chaos." },
      { title: "For All Mankind", start: "11:30 PM", end: "12:30 AM", width: 2, rating: "TV-MA", genres: ["Sci-Fi","Drama"], summary: "What if the Soviets landed on the moon first?" },
    ],
  },
  {
    number: "195",
    name: "Peacock",
    category: "STREAMING HIGHLIGHT",
    preview: "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1400&q=80",
    programs: [
      { title: "The Office (Full Run)", start: "8:00 PM", end: "8:30 PM", width: 1, rating: "TV-14", genres: ["Comedy"], summary: "Dunder Mifflin. The show that defined comfort rewatching." },
      { title: "Parks and Recreation", start: "8:30 PM", end: "9:00 PM", width: 1, rating: "TV-PG", genres: ["Comedy"], summary: "Pawnee, Indiana. Leslie Knope forever." },
      { title: "Yellowstone", start: "9:00 PM", end: "10:00 PM", width: 2, rating: "TV-MA", genres: ["Drama","Western"], summary: "Kevin Costner holding his ranch together." },
      { title: "Psych", start: "10:00 PM", end: "11:00 PM", width: 2, rating: "TV-PG", genres: ["Comedy","Crime"], summary: "Shawn Spencer. Fake psychic. Real funny." },
      { title: "Battlestar Galactica", start: "11:00 PM", end: "12:30 AM", width: 3, rating: "TV-14", genres: ["Sci-Fi","Drama"], summary: "So say we all. The reboot that proved sci-fi can be prestige." },
    ],
  },
];
